import _ from 'underscore';
import request from 'superagent';
import React from 'react';
import FormErrors from 'helpers/FormErrors';
import I18n from 'helpers/I18n';

import AudioPlayer from 'components/application/AudioPlayer';
import LoginPage   from 'components/application/LoginPage';
import SendUserbar from 'components/application/SendUserbar';
import Wizard      from 'components/application/Wizard';
import Youtube     from 'components/application/Youtube';
import TestResults from 'components/application/TestResults';

class TestWizard extends React.Component {
  static propTypes = {
    submitURL:         React.PropTypes.string.isRequired,
    submitMethod:      React.PropTypes.oneOf(["POST", "PATCH"]).isRequired,
    sendUserbarURL:    React.PropTypes.string.isRequired,
    sendUserbarMethod: React.PropTypes.oneOf(["POST"]).isRequired,
    backURL:           React.PropTypes.string.isRequired,
    test:              React.PropTypes.object.isRequired,
    setView:           React.PropTypes.func.isRequired,
  }

  state = {
    choices:    {},
    submitting: false,
    errors:     new FormErrors(),
  }

  beganTest() {
    return !_.isEmpty(this.state.choices);
  }

  handleSelectedAnswerChange = (questionId, selectedAnswerId) => {
    // timeout is necessary for non-immediate rendering
    if (this.changeAnswerTimeout) {
      clearTimeout(this.changeAnswerTimeout);
    }
    this.changeAnswerTimeout = setTimeout(() => {
      const newChoices = _.extend({}, this.state.choices);
      newChoices[questionId] = selectedAnswerId;
      this.setState({ choices: newChoices });
      this.refs.wizard.pageDone();
    }, 250);
  }

  getModelForSubmit() {
    const result = {
      topic_id: this.props.test.topic.id,
      submission: []
    };
    this.props.test.questions.forEach(q => {
      result.submission.push({
        question_id: q.id,
        selected_answer_id: this.state.choices[q.id]
      });
    });
    return result;
  }

  handleTestDone = () => {
    this.setState({ submitting: true, errors: new FormErrors() });
    const modelForSubmit = this.getModelForSubmit();
    request
      .post(this.props.submitURL)
      .send(modelForSubmit)
      .set("X-CSRF-Token", window.SessionManager.getCSRFToken())
      .set("Accept", "application/json")
      .then(res => {
        this.setState({ submitting: false });

        const correctAnswers = {};
        res.body.answers.forEach(a => {
          correctAnswers[a.question_id] = a.correct_answer_id;
        }, this);

        if (!window.SessionManager.isLoggedIn()) {
          this.props.setView(LoginPage, {
            testResultUUID: res.body.uuid,
            topicID: this.props.test.topic.id
          });
        } else {
          history.replaceState({}, '', Routes.testResultURL(res.body.uuid));
          this.props.setView(TestResults, {
            sendUserbarURL:    this.props.sendUserbarURL,
            sendUserbarMethod: this.props.sendUserbarMethod,
            backURL:           this.props.backURL,
            uuid:              res.body.uuid,
            questions:         res.body.questions,
            answers:           res.body.answers,
            score:             res.body.correctly_answered_questions_count,
            totalQuestions:    res.body.total_questions_count,
            userbarToken:      res.body.userbar_token,
            topicId:           res.body.topic.id
          });
        }
      })
      .catch(err => {
        let errors;
        if (err.status === 422) {
          errors = new FormErrors(err.response.body.errors.submission, "test_wizard.errors");
        } else {
          errors = new FormErrors({ errors: ["generic_error"] }, "test_wizard.errors");
        }
        this.setState({ errors, submitting: false });
      });
  }

  render() {
    const pages = this.props.test.questions.map((q, i) => {
      return (
        <Wizard.Page key={q.id}>
          <TestWizard.Question id={q.id}
                               number={i + 1}
                               text={q.text}
                               audioURL={q.audio_url}
                               isPlaying={this.beganTest()}
                               answerOptions={q.answer_options}
                               selectedAnswerId={this.state.choices[q.id]}
                               onSelectedAnswerChange={this.handleSelectedAnswerChange}/>
          <TestWizard.AudioPreloader audioURL={(this.props.test.questions[i + 1] || {}).audio_url}/>
        </Wizard.Page>
      );
    });

    let alert;
    if (this.state.errors.hasAny()) {
      alert = (
        <div className="alert alert-danger">
          {this.state.errors.firstError()}
        </div>
      );
    }

    return (
      <div>
        <div className="page-header">
          <h1 className="m-b-0">{this.props.test.topic.name}&nbsp;<small>{this.props.test.topic.level_name}</small></h1>
        </div>
        <div className="row">
          <div className="col-md-8">
            {alert}
            <Wizard className="test-wizard" ref="wizard" onDone={this.handleTestDone} submitting={this.state.submitting}>
              {pages}
            </Wizard>
            <ul className="list-inline">
              <li><a href={this.props.backURL}>{I18n.t("test_wizard.back")}</a></li>
            </ul>
          </div>
          <div className="col-md-4">
            <div className="m-b-05l">
              <Youtube videoEmbedURL={this.props.test.topic.video_url} controls={true} allowFullScreen={true}/>
            </div>
            <p>{this.props.test.topic.description}</p>
          </div>
        </div>
      </div>
    );
  }
}

class TestWizardQuestion extends React.Component {
  static propTypes = {
    id: React.PropTypes.number.isRequired,
    number: React.PropTypes.number.isRequired,
    text: React.PropTypes.string.isRequired,
    audioURL: React.PropTypes.string,
    isPlaying: React.PropTypes.bool,
    answerOptions: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
    selectedAnswerId: React.PropTypes.number,
    onSelectedAnswerChange: React.PropTypes.func.isRequired,
  }

  handleSelectedAnswerChange = (e) => {
    const selectedAnswerId = Number(e.target.value);
    this.props.onSelectedAnswerChange(this.props.id, selectedAnswerId);
  }

  render() {
    let audio = null;
    if (this.props.audioURL) {
      audio = <AudioPlayer isPlaying={this.props.isPlaying} audioURL={this.props.audioURL}/>;
    }
    const radios = this.props.answerOptions.map(ao => {
      return <span key={ao.id} className="radio">
        <label className="answer">
          <input name={this.props.id}
                 type="radio"
                 value={ao.id}
                 defaultChecked={this.props.selectedAnswerId === ao.id}
                 onChange={this.handleSelectedAnswerChange}/>
          <span className="radio-label">{ao.text}</span>
        </label>
      </span>
    });
    return (
      <div className="question">
        <h4>{`${I18n.t("test_wizard.question")} ${this.props.number}`}</h4>
        <p className="question-prominent p-t-20">{this.props.text}</p>
        {audio}
        <div className="form-group p-t-15">
          <h4>{I18n.t("test_wizard.answer_options")}</h4>
          {radios}
        </div>
      </div>
    );
  }
}

class TestWizardAudioPreloader extends React.Component {
  static propTypes = {
    audioURL: React.PropTypes.string
  }

  componentDidMount() {
    if (!this.props.audioURL) {
      return;
    }
    this.refs.audio.src = this.props.audioURL;
  }

  render() {
    return (
      <audio ref="audio"></audio>
    )
  }
}

TestWizard.Question = TestWizardQuestion;
TestWizard.AudioPreloader = TestWizardAudioPreloader;
export default TestWizard;



// WEBPACK FOOTER //
// ./app/javascript/components/application/TestWizard.jsx